export const GATEWAY_REASONING_EFFORTS = [
    'max',
    'xhigh',
    'high',
    'medium',
    'low',
    'minimal',
    'none',
];

export const REASONING_EFFORT_LABELS = {
    max: 'Макс',
    xhigh: 'Оч. выс.',
    high: 'Высокий',
    medium: 'Средний',
    low: 'Низкий',
    minimal: 'Мин.',
    none: 'Выкл',
};

export function modelHasReasoning(model) {
    return !!(model && model.reasoning);
}

export function getReasoningEfforts(reasoning) {
    if (!reasoning || typeof reasoning !== 'object') return [];
    let efforts = reasoning.supported_efforts;
    if (!Array.isArray(efforts) || !efforts.length) {
        efforts = [...GATEWAY_REASONING_EFFORTS];
    } else {
        efforts = efforts.map(String).filter(Boolean);
    }
    if (reasoning.mandatory) {
        efforts = efforts.filter((e) => e !== 'none');
    }
    return efforts;
}

export function resolveReasoningEffort(reasoning, requested) {
    const efforts = getReasoningEfforts(reasoning);
    if (!efforts.length) return null;
    if (requested && efforts.includes(requested)) return requested;

    const def = reasoning?.default_effort;
    if (def === 'none' && efforts.includes('none') && reasoning?.default_enabled === false) {
        return 'none';
    }
    if (def && def !== 'none' && efforts.includes(def)) return def;
    if (reasoning?.default_enabled === false && efforts.includes('none')) return 'none';
    if (efforts.includes('medium')) return 'medium';
    return efforts[0];
}
